import React, { ReactElement } from 'react';
import { Checkbox, CheckboxGroup } from 'idsk-react-components';
import './assignMeCheckbox.scss';
import UserRole from '../../../../model/currentuser/UserRole';
import { useUserContext } from '../../../../context/UserContext';
import { processInCorrectStates } from '../../../../function/permissions';
import Secured from '../../../Secured';

interface Props {
  id: string;
  children: ReactElement;
  setAssignedList: (assignedList: Array<string>) => void;
  assignedList: Array<string>;
}

const AssignMeCheckbox = ({
  id, children,
  assignedList, setAssignedList,
}: Props): ReactElement => {
  const { legislationProcess } = useUserContext();

  const handleUpdate = async (e): Promise<void> => {
    if (e.target.checked) {
      setAssignedList([...assignedList, e.target.value]);
    } else {
      setAssignedList(assignedList.filter((i) => i !== e.target.value));
    }
  };

  return (
    <Secured
      allowForRoles={[UserRole.VYHODNOCOVATEL]}
      additionalCheck={processInCorrectStates(legislationProcess)}
      elseChildren={children}
    >
      <CheckboxGroup small className="assign-me-checkbox-wrapper">
        <Checkbox id={id} className="assign-me-checkbox" value={id} onClick={handleUpdate}>
          {children}
        </Checkbox>
      </CheckboxGroup>
    </Secured>
  );
};

export default AssignMeCheckbox;
